import React from "react";
import { FiniteListWithAsyncLoaderAbstract, ListProps } from "shared/components/Components";
import { useMercuryContext } from "../context";

interface OwnerFilterProps extends ListProps {
  data?: any[];
  context?: any;
}
class OwnerFilter extends FiniteListWithAsyncLoaderAbstract {
  async fetch() {
    const props = this.props as unknown as OwnerFilterProps;
    const data = props.data || [];
    
    if (data.length > 0) {
      return data;
    } else {

      const { selectedApp, umsClient } = this.props.context;

      const { data } = await umsClient.get(`/ums-v1/users/${selectedApp}/listUsers?includeDeactivated=false`);
      let ownerList = data.map((item: any) => {
        return {
          title: item.name,
          value: item._id,
        };
      });
      ownerList.push({
        title: "Unclaimed",
        value: null,
      });
      return ownerList;
    }
  }
}

export default (props: ListProps) => {
  const context = useMercuryContext();
  return <OwnerFilter context={context} {...props} />;
};
